import { Button, Input, Modal } from '@hydrodigital/design-system';
import {
	Combobox,
	ComboboxInput,
	ComboboxContent,
	ComboboxList,
	ComboboxItem,
	ComboboxEmpty,
} from '@hydrodigital/combobox';
import { notification } from 'antd';
import { useEffect, useState } from 'react';
import InfrastructureService from '../../../domain/Infrastructure/InfraestructureService';
import KpiService from '../../../domain/Kpi/KpiService';
import useDebounce from '../../../hooks/useDebounce';
import LocationCombobox from '../../General/LocationCombobox';
import './index.scss';

const infrastructureService = new InfrastructureService();
const kpiService = new KpiService();
export interface IProps {
	isModalOpen: boolean;
	onSuccess: Function;
	onCancel: Function;
	selectedKpi: any;
}

export default function CreateKpiModal({ isModalOpen, selectedKpi, onSuccess, onCancel }: IProps) {
	const [nameKpi, setNameKpi] = useState('');
	const [infraestructures, setInfraestructures] = useState<any[]>([]);
	const [parameters, setParameters] = useState<any[]>([]);
	const [location, setLocation] = useState('');
	const [infrastructure, setInfrastructure] = useState<any>(null);
	const [parameter, setParameter] = useState<any>(null);
	const [loaded, setLoaded] = useState(true);
	const [detailsKpi, setdetailsKpi] = useState<any>(null);
	const [searchAsset, setSearchAsset] = useState('');
	const debouncedSearchAsset = useDebounce(searchAsset, 300);

	const handleClickSelectLocation = (value: any) => {
		setInfraestructures([]);
		setInfrastructure(null);
		setParameters([]);
		setParameter(null);
		setLocation(value);
	};

	async function handleSearchInfrastructures(search: any, locationId?: any) {
		if (location === '' && !locationId) return;
		const response = await infrastructureService.getInfraestructureInUse(
			locationId ? locationId : location,
			1,
			50,
			search,
			null,
			0,
			null,
		);
		setInfraestructures(response.data);
	}

	function handleSetParameters(val: any) {
		const selectedParameter = infraestructures.find((p) => String(p.infraestructureId) === String(val));
		if (selectedParameter) {
			setParameters(selectedParameter.measurementParameters);
		}
	}

	async function handlePostKpi() {
		if (parameter != null) {
			const response = await kpiService.postKpi(nameKpi, true, parameter, selectedKpi);
			if (response) {
				if (selectedKpi) {
					notification.success({
						message: 'Successful',
						description: 'Kpi edited successfully',
					});
				} else {
					notification.success({
						message: 'Successful',
						description: 'Kpi created successfully',
					});
				}
				setNameKpi('');
				setLocation('');
				setInfrastructure(null);
				setParameter(null);
				onSuccess();
			}
		}
	}

	async function handleGetKpiDetails() {
		const response = await kpiService.getKpiDetails(selectedKpi);
		setdetailsKpi(response);
		// setNameKpi(response.name);
		setLocation(response.locationId);
		// setInfrastructure(response.infrastructureId);
		// setParameter(response.parameterId);
	}

	async function setKPIDetails() {
		kpiService.getKpiDetails(selectedKpi).then(async (response) => {
			setNameKpi(response.name);
			setLocation(response.locationId);
			await handleSearchInfrastructures('', response.locationId);
			setInfrastructure(response.infrastructureId);
			await handleSetParameters(response.infrastructureId);
			setParameter(response.parameterId);
			setLoaded(true);
		});
	}

	useEffect(() => {
		if (selectedKpi) {
			setLoaded(false);
			setKPIDetails();
		}
	}, []);

	useEffect(() => {
		if (location && loaded) {
			handleSearchInfrastructures('');
		}
	}, [location]);

	useEffect(() => {
		if (location && loaded) {
			handleSearchInfrastructures(debouncedSearchAsset);
		}
	}, [debouncedSearchAsset]);

	useEffect(() => {
		// if (infrastructure && loaded) {
		handleSetParameters(infrastructure);
		// }
	}, [infrastructure]);

	return (
		<Modal
			isOpen={isModalOpen}
			onClose={() => {
				setNameKpi('');
				setLocation('');
				setInfrastructure(null);
				setParameter(null);
				onCancel();
			}}
			size="m"
			closeOnOverlayClick={false}
			closeOnEscape={true}
			showCloseButton={false}
		>
			<Modal.Header>
				<Modal.Title text={selectedKpi ? 'EDIT KPI' : 'CREATE KPI'} />
			</Modal.Header>

			<Modal.Content>
				<div className="flex column px-4 gap-2">
					<div className="separator mb-2" />
					<div className="mb-1">
						<Input
							id="nameKpi"
              size='small'
							label="Name KPI"
							value={nameKpi}
							onChange={(e) => setNameKpi(e.target.value)}
							placeholder="Enter KPI name"
						/>
					</div>
					<div className="mb-1" style={{ minWidth: '200px', width: '100%' }}>
						<LocationCombobox
							value={location || null}
							onValueChange={(val) => handleClickSelectLocation(val || '')}
							label="Location"
						/>
					</div>

					<div className="mb-1">
						<Combobox
							items={infraestructures.map((d) => ({
								value: String(d.infraestructureId),
								label: d.infraestructureName,
							}))}
							value={infrastructure ? String(infrastructure) : undefined}
							onValueChange={(val) => setInfrastructure(val)}
							onClear={() => setInfrastructure(null)}
							searchable
							onSearchChange={(val) => setSearchAsset(val)}
							size="small"
						>
							<ComboboxInput placeholder="Select an asset" label="Asset" />
							<ComboboxContent>
								<ComboboxEmpty>No assets found.</ComboboxEmpty>
								<ComboboxList>
									{(item) => (
										<ComboboxItem key={item.value} value={item}>
											{item.label}
										</ComboboxItem>
									)}
								</ComboboxList>
							</ComboboxContent>
						</Combobox>
					</div>

					<div className="mb-2">
						<Combobox
							items={(parameters || []).map((p) => ({
								value: String(p.paremeterId),
								label: p.paremeterName,
							}))}
							value={parameter ? String(parameter) : undefined}
							onValueChange={(val) => setParameter(val)}
							onClear={() => setParameter(null)}
							size="small"
						>
							<ComboboxInput placeholder="Select a parameter" label="Parameter" />
							<ComboboxContent>
								<ComboboxEmpty>No parameters found.</ComboboxEmpty>
								<ComboboxList>
									{(item) => (
										<ComboboxItem key={item.value} value={item}>
											{item.label}
										</ComboboxItem>
									)}
								</ComboboxList>
							</ComboboxContent>
						</Combobox>
					</div>
				</div>
			</Modal.Content>

			<Modal.Footer className='flex justify-between px-4'>
				<Button
					label="Cancel"
					variant="secondary"
          showIcon={false}
					onClick={() => {
						setNameKpi('');
						setLocation('');
						setInfrastructure(null);
						setParameter(null);
						onCancel();
					}}
				/>

				<Button
					label="Accept"
          showIcon={false}
					onClick={() => {
						handlePostKpi();
					}}
				/>
			</Modal.Footer>
		</Modal>
	);
}
